
import React, { RefObject } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import LegalSection from './LegalSection';

interface LegalPaymentMethodsProps {
  paymentRef: RefObject<HTMLHeadingElement>;
}

const LegalPaymentMethods: React.FC<LegalPaymentMethodsProps> = ({ paymentRef }) => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];

  return (
    <LegalSection id="payment-methods" 
      title={currentLanguage === 'de' ? 'Zahlungsmethoden' : 
             currentLanguage === 'en' ? 'Payment Methods' : 
             currentLanguage === 'fr' ? 'Méthodes de Paiement' : 'Metodi di Pagamento'} 
      titleRef={paymentRef}>
      <p className="mb-4 text-gray-300">
        {currentLanguage === 'de' ? 
          'Wir akzeptieren die folgenden Zahlungsmethoden:' : 
          currentLanguage === 'en' ? 
          'We accept the following payment methods:' :
          currentLanguage === 'fr' ? 
          'Nous acceptons les méthodes de paiement suivantes:' :
          'Accettiamo i seguenti metodi di pagamento:'}
      </p>
      <ul className="list-disc pl-6 space-y-2 text-gray-300">
        <li>Banküberweisung / Bank Transfer</li>
        <li>Twint</li>
        <li>Kreditkarte / Credit Card</li>
        <li>PayPal</li>
      </ul>
      <p className="italic text-sm text-gray-400 mt-4">
        * Bitte passen Sie die akzeptierten Zahlungsmethoden nach Ihren tatsächlichen Präferenzen an.
      </p>
    </LegalSection>
  );
};

export default LegalPaymentMethods;
